import React from 'react';
import Types from 'prop-types';
import { Cross, Menu } from '@transferwise/icons';
import Logo from '../Logo';
import MenuToggle from '../common/MenuToggle';
var Header = function Header(_ref) {
  var className = _ref.className,
    menuClassName = _ref.menuClassName,
    onToggle = _ref.onToggle,
    isMenuOpen = _ref.isMenuOpen,
    inverse = _ref.inverse,
    logoLink = _ref.logoLink,
    isTestEnvironment = _ref.isTestEnvironment;
  return /*#__PURE__*/React.createElement("div", {
    className: "tw-public-nav__header"
  }, /*#__PURE__*/React.createElement(MenuToggle, {
    isMenuOpen: isMenuOpen,
    onToggle: onToggle,
    className: [menuClassName, 'tw-public-nav__menu-toggle--open']
  }, /*#__PURE__*/React.createElement(Menu, {
    size: 24
  })), /*#__PURE__*/React.createElement(Logo, {
    className: className,
    link: logoLink,
    inverse: inverse,
    isTestEnvironment: isTestEnvironment
  }), /*#__PURE__*/React.createElement(MenuToggle, {
    isMenuOpen: isMenuOpen,
    onToggle: onToggle,
    className: [menuClassName, 'tw-public-nav__menu-toggle--close']
  }, /*#__PURE__*/React.createElement(Cross, {
    size: 24
  })));
};
Header.defaultProps = {
  className: '',
  menuClassName: '',
  inverse: false,
  logoLink: '/',
  isTestEnvironment: false
};
export default Header;